module.exports = __webpack_public_path__ + "img/Kettenfahrzeug.578c2a79.svg";